import React, { useEffect, useMemo, useState } from 'react';
import './typewriter.css';

const Typewriter = (props) => {
  
  const {title_1,title_2,title_3,title_4,title_5,title_6} = props.txt
  const textArray = useMemo(
    () => [title_1, title_2, title_3, title_4, title_5, title_6],
    [title_1, title_2, title_3, title_4, title_5, title_6]
  );

  const [i, setI] = useState(0);              // Character index
  const [a, setA] = useState(0);              // Phrase index
  const [isBackspacing, setIsBackspacing] = useState(false);
  const [text, setText] = useState('');

  const speedForward = 120;
  const speedBackspace = 50;
  const delayBeforeBackspace = 1200;
  const delayBetweenWords = 500;

  useEffect(() => {
    const currentPhrase = textArray[a];
    let timeout;

    if (!isBackspacing) {
      if (i < currentPhrase.length) {
        timeout = setTimeout(() => {
          setText(prev => prev + currentPhrase.charAt(i));
          setI(prev => prev + 1);
        }, speedForward);
      } else {
        timeout = setTimeout(() => setIsBackspacing(true), delayBeforeBackspace);
      }
    } else {
      if (text.length > 0) {
        timeout = setTimeout(() => {
          setText(prev => prev.slice(0, -1));
        }, speedBackspace);
      } else {
        timeout = setTimeout(() => {
          setIsBackspacing(false);
          setI(0);
          setA((a + 1) % textArray.length);
        }, delayBetweenWords);
      }
    }

    return () => clearTimeout(timeout);
  }, [i, isBackspacing, text, a, textArray]);

  return (
    <div id="output">
      <h1 className="cursor">{text}</h1>
    </div>
  );
}

export default Typewriter;
